export default {
  common: {
    back: '返回',
    cancel: '取消',
    noBooking: '找不到預約資訊',
    openFromBooking: '請從預約詳情重新進入。',
    loadFailed: '載入失敗',
    retry: '重試'
  },
  views: {
    change: {
      policy:
        '更改政策：僅可更改為同一乘車日、原車次發車前且有空位的車次；可多次更改。乘車區間和人數不能更改。',
      confirmSelect: '確認更改',
      submittedTitle: '預訂已更改',
      submittedThanks: '感謝您的預訂，請返回首頁查看出票結果'
    },
    trainList: {
      vehicleInfo: '車輛資訊',
      ticketName: '小田急浪漫特快',
      travelDate: '參加日期：',
      route: '出發和到達：',
      ticketCount: '預約數量：',
      trainType: '車型：',
      seatClass: '座位類型：',
      preference: '位置偏好：',
      preOrderNote: '',
      selectStation: '選擇車站',
      from: '出發',
      to: '到達',
      swap: '交換出發站和到達站',
      selectTrain: '選擇車次',
      select: '選擇',
      book: '預訂',
      seatAvailable: '餘票充足',
      seatLimited: '餘票不足',
      soldOut: '車票售罄',
      notOnSale: '尚未開售',
      noTimeRanges: '暫無可預約時段',
      noTrains: '此時段暫無車次'
    },
    seat: {
      title: '請選擇座位',
      ticketCount: '預約數量：',
      selectMethod: '選擇座位方式',
      selectByPreference: '根據條件指定',
      selectBySeatMap: '根據座位表指定',
      preference: '位置偏好',
      car: '車廂',
      noCarPreference: '未指定',
      selectSeats: '請選擇座位（{{selected}}/{{total}}）',
      seatLabel: '座位 {{seat}}',
      seatMapDescription: '*A/D座位靠窗，B/C座位靠走道。無法跨車廂指定座位。',
      noSeats: '目前車廂沒有可選座位',
      noTrain: '未選擇車次',
      selectTrainFirst: '請返回並選擇車次。',
      next: '下一步'
    },
    confirm: {
      trainConfirm: '車次確認',
      ticketName: '小田急浪漫特快',
      route: '出發和到達：',
      travelDate: '參加日期：',
      ticketCount: '預約數量：',
      trainType: '車型：',
      seatClass: '座位類型：',
      preference: '位置偏好：',
      confirmSelect: '確認選擇',
      noTrain: '未選擇車次',
      selectTrainFirst: '請返回並選擇車次。'
    },
    submitted: {
      title: '預約已提交',
      thanks: '感謝您的預訂，請返回首頁查看出票結果',
      ticketName: '小田急浪漫特快',
      route: '出發和到達：',
      travelDate: '參加日期：',
      ticketCount: '預約數量：',
      trainType: '車型：',
      seatClass: '座位類型：',
      preference: '位置偏好：',
      backHome: '返回首頁'
    },
    notFound: {
      title: '頁面不存在',
      message: '請檢查網址後重試。'
    }
  }
};
